import { SegmentedControl } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";

interface ViewSwitchProps {
  /** Base path, e.g. "/gallery" or "/generate". */
  base: string;
  options: { label: string; value: string }[];
}

/**
 * URL-synced tab switcher. Replaces the per-section GenerateSwitch/GallerySwitch
 * with one parameterised component.
 */
export default function ViewSwitch({ base, options }: ViewSwitchProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const current = options.find((o) => pathname.startsWith(`${base}/${o.value}`));
  if (current === undefined) throw new Error(`ViewSwitch: "${pathname}" matches no option under "${base}"`);

  return (
    <SegmentedControl
      value={current.value}
      onChange={(v) => navigate(`${base}/${v}`)}
      data={options}
      size="sm"
    />
  );
}
